import React from "react";

import { ScoreComparison } from "~/sdks/LocalContent/components/ScoreComparison";
import { ScoreText } from "~/sdks/LocalContent/components/ScoreText";
import { ScorePoiList } from "~/sdks/LocalContent/components/ScorePoiList";

import type { RootProps } from "../../types";

import * as styles from "./styles";

export function Content({
  activeScore,
  activeScoreData,
  markersData,
  isMarkersLoading = false,
}: {
  activeScore: RootProps["activeScore"];
  activeScoreData?: RootProps["activeScoreData"];
  markersData?: RootProps["markersData"];
  isMarkersLoading?: boolean;
}) {
  return (
    <div
      className={styles.container}
      data-testid="categories-toggle-score-content"
    >
      <ScoreComparison
        scoreKey={activeScore}
        locationScoreValue={activeScoreData?.value}
        comparedTo={activeScoreData?.geographies?.g30}
      />
      <ScoreText text={activeScoreData?.text} />
      <ScorePoiList
        isLoading={isMarkersLoading}
        pois={markersData}
        showPois={false}
        scoreKey={activeScore}
      />
    </div>
  );
}
